const productCardUi = {
  card: document.querySelectorAll(".product-card"),
  colorOption: document.querySelectorAll(".product-card__color-option"),
}

window.addEventListener("load", (event) => {
  productCardUi.card.forEach((item) => {
    const colorOptionText = item.querySelectorAll(".color-option-text")[0]
    const itemLength = item.querySelectorAll(".color-option").length
    const showMoreCount = itemLength - 2

    if (itemLength > 3) {
      colorOptionText.style.display = "block"
      colorOptionText.innerHTML = `+${showMoreCount}`

      hideColorOptions(item.querySelectorAll(".color-option"))
    } else {
      colorOptionText.style.display = "none"
    }
  })
})

const hideColorOptions = (optionsElement) => {
  optionsElement.forEach((item, index) => {
    if (index > 1) {
      item.style.display = "none"
    }
  })
}
